import {getMyDetails$, getUser$, getUserByQuery$, updateMyProfile$} from "../services/users";
import * as R from 'ramda';
import {authPoll, authStateChange, logout, networkError, uiError, uiInfo} from "./ui";
import {registerAccount$, resetPassword$, updatePassword$} from "../services/common";
import {notification} from "antd";
import React from "react";
import {getCompany} from "./companies";

export const ADD_USERS = 'ADD_USERS';
export const addUsers = (users) => ({type: ADD_USERS, payload: users});
export const API_GET_USER = 'API_GET_USER';
export const getUsers = (id) => ({type: API_GET_USER, payload: {id}});
export const API_GET_USERS_DONE = 'API_GET_USERS_DONE';
export const getUsersDone = (response) => ({type: API_GET_USERS_DONE, payload: response});
export const CLEAR_USER_SEARCH = 'CLEAR_USER_SEARCH';
export const clearUserSearch = () => ({ type: CLEAR_USER_SEARCH, payload: {} });

export const API_GET_USER_QUERY_START = 'API_GET_USER_QUERY_START';
export const API_GET_USER_QUERY_RESULTS = 'API_GET_USER_QUERY_RESULTS';
export const API_GET_USER_QUERY_DONE = 'API_GET_USERS_QUERY_DONE';

export const getUserWithCompany = (id) => async (dispatch, getState) => {
  try {
    const {response, status} = await(getUser$({userId: id})).toPromise();
    const users = response.results;
    users.map(item => {
      getUsersDone(item);
      const companyid = item.companyid;
      if (!R.view(['companies', companyid], getState())) dispatch(getCompany(id));
      return true;
    });
  } catch (error) {
    dispatch(networkError({...error, number: '10112-'+error.status}));
  }
};

export const getUsersQuery = (q) => async (dispatch, getState) => {
  try {
    dispatch({type: API_GET_USER_QUERY_START, payload: {q}});
    if (!q) {
      dispatch(clearUserSearch());
      return;
    }
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let {response, status} = await getUserByQuery$({q, offset: nextOffset}).toPromise();
      if (status === 204) {
        dispatch({type: API_GET_USER_QUERY_DONE, payload: {}});
        return;
      }
      if (!response) {
        dispatch({type: API_GET_USER_QUERY_DONE, payload: {}});
        return;
      }
      let {results, size} = response;
      theSize = size;
      soFar += results.length;
      if (getState().ui.userSearchTerm !== q) return;
      if (results.length > 0) dispatch({type: API_GET_USER_QUERY_RESULTS, payload: {results}});
      nextOffset = R.last(results).id;
    } while (soFar < theSize);
    dispatch({type: API_GET_USER_QUERY_DONE, payload: {}});
  } catch (error) {
    dispatch(networkError({...error, number: '10062-'+error.status}));
    dispatch({type: API_GET_USER_QUERY_DONE, payload: {}});
  }
};

export const getAccount = () => async (dispatch, getState) => {
  try {
    let {response, status} = await getMyDetails$().toPromise();
    let user = response;
    if (user) {
      dispatch(addUsers([user]))
    }
  } catch (error) {
    dispatch(networkError({...error, number: '10063-'+error.status}));
  }
};

export const resetPassword = (email) => async (dispatch, getState) => {
  try {
    let { response, status } = await resetPassword$({ email }).toPromise();
  } catch (error) {
    let { response, status } = error;
    if (status === 404) {
    } else {
      dispatch(networkError({...error, number: '10064-'+error.status}));
    }
  }
};

export const updatePassword = (sid, newPassword, history) => async (dispatch, getState) => {
  try {
    let { response, status } = await updatePassword$({ sid, newPassword }).toPromise();
    dispatch(authPoll());
    history.push('/');
  } catch (error) {
    if (error && error.status === 400 && error.response.code === 'invalid_nonce') {
      dispatch(uiError(<span>Your password reset link seems to have expired. Please <a
          onClick={() => dispatch(authStateChange('forgotPassword'))}>click here</a> to request another.</span>));
      console.log(error);
    } else {
      dispatch(networkError({...error, number: '10065-'+error.status}));
    }
  }
};

export const leaveCompany = () => async (dispatch, getState) => {
  try {
    let profile = {
      companyid: null
    };
    await updateMyProfile$({ profile }).toPromise();
    dispatch(logout());
  } catch (error) {
    dispatch(networkError({...error, number: '10066-'+error.status}));
  }
};

export const updateProfileFields = (profile) => async (dispatch, getState) => {
  try {
    await updateMyProfile$({ profile }).toPromise();
    dispatch(getMyProfile());
  } catch (error) {
    dispatch(networkError({...error, number: '10067-'+error.status}));
  }
};

export const updatePrivacySettings = (iscontactinfoprivate, iscontactinfofullyprivate) => async (dispatch, getState) => {
  try {
    let profile = {
      iscontactinfoprivate,
      iscontactinfofullyprivate
    };
    await updateMyProfile$({ profile }).toPromise();
    dispatch(getMyProfile());
  } catch (error) {
    dispatch (networkError({...error, number: '10068-'+error.status}));
  }
};

export const updateNotificationSettings = ({
                                             emailsettingbidinviteson,
                                             emailsettingbidactivityon,
                                             emailsettingprebidon,
                                             emailsettingbiddueon,
                                             emailsettingprojectdueon,
                                             emailsettingprojectinviteson,
                                             emailsettingprojectactivityon,
                                             emailsettingprojectdailylogon,
                                           }) => async (dispatch, getState) => {
  try {
    let profile = {
      emailsettingbidinviteson,
      emailsettingbidactivityon,
      emailsettingprebidon,
      emailsettingbiddueon,
      emailsettingprojectdueon,
      emailsettingprojectinviteson,
      emailsettingprojectactivityon,
      emailsettingprojectdailylogon,
    };
    await updateMyProfile$({ profile }).toPromise();
    dispatch(getMyProfile());
  } catch (error) {
    dispatch (networkError({...error, number: '10069-'+error.status}));
  }
};

export const GET_MY_PROFILE_DONE = 'GET_MY_PROFILE_DONE';

export const getMyProfile = () => async (dispatch, getState) => {
  try {
    let { response, status } = await getMyDetails$().toPromise();
    dispatch({ type: GET_MY_PROFILE_DONE, payload: response });
  } catch (error) {
    let state = getState();
    if (state.ui.authState === 'signedIn') {
      dispatch(networkError({...error, number: '10070-'+error.status}));
    }
  }
};

export const initiatePasswordReset = (email) => async (dispatch, getState) => {
  try {
    let { response, status } = await resetPassword$({ email }).toPromise();
    notification.info({
      message: 'Password Change Request Received',
      description: 'Check your email for instructions on changing your password'
    });
  } catch (error) {
    dispatch(networkError({...error, number: '10071-'+error.status}));
  }
};

export const registerAccount = (sid, user, newPassword, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await registerAccount$({ sid, user, newPassword }).toPromise();
    if (status === 201) {
      dispatch(authPoll());
      callback && callback();
    } else {
      dispatch(uiInfo('Account registration failed'));
    }
  } catch (error) {
    dispatch(networkError({...error, number: '10072-'+error.status}));
  }
};



// WEBPACK FOOTER //
// ./src/actions/users.js